const DeltaModeFactor = {
    [WheelEvent.DOM_DELTA_PIXEL]: 1,
    [WheelEvent.DOM_DELTA_LINE]: 16,
    [WheelEvent.DOM_DELTA_PAGE]: 976,
};

function getWheelDelta(wheelEvent, propName) {
    return wheelEvent[propName] * DeltaModeFactor[wheelEvent.deltaMode];
}

export default getWheelDelta;
